import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  currentName: 'none',
  isHostTalking: false,
};

const VoReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_CURRENT_VO_NAME:
      return {
        ...state,
        currentName: payload,
        isHostTalking: true,
      };

    case REDUX_ACTIONS.STOP_VO:
    case REDUX_ACTIONS.SHOW_DIRECT_MESSAGE:
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        currentName: 'none',
        isHostTalking: false,
      };

    case REDUX_ACTIONS.ON_VO_ENDS:
      return {
        ...state,
        isHostTalking: false,
      };

    default:
      return state;
  }
};

export default VoReducer;
